export default __webpack_public_path__ + "static/media/bulb.6f1ddca2.svg";